(function () {
  if (window.__nativeAddToCartButtonsInitialized) {
    return;
  }
  window.__nativeAddToCartButtonsInitialized = true;

  var SECTION_SELECTOR = "[data-native-atc-section]";
  var BUTTON_SELECTOR = "[data-native-atc-button]";
  var VARIANT_ATTR = "data-native-atc-variant-id";
  var INITIALIZED_ATTR = "nativeAtcButtonsInitialized";
  var cleanupMap = new WeakMap();

  var findSections = function (root) {
    if (!root || !root.querySelectorAll) {
      return [];
    }
    return Array.prototype.slice.call(root.querySelectorAll(SECTION_SELECTOR));
  };

  var addItemToCart = function (variantId, button) {
    if (!variantId || !button) {
      return;
    }
    var root =
      window.Shopify && window.Shopify.routes_root
        ? window.Shopify.routes_root
        : window.theme && window.theme.routes && window.theme.routes.root
          ? window.theme.routes.root
          : "/";
    var addPath =
      window.theme &&
      window.theme.routes &&
      window.theme.routes.cart &&
      window.theme.routes.cart.add
        ? window.theme.routes.cart.add
        : "/cart/add";
    var basePath =
      window.theme &&
      window.theme.routes &&
      window.theme.routes.cart &&
      window.theme.routes.cart.base
        ? window.theme.routes.cart.base
        : "/cart";
    var cleanedRoot = !root || root === "/" ? "" : root.replace(/\/$/, "");

    var buildEndpoint = function (path) {
      if (!path) {
        return "";
      }
      var normalized = path.startsWith("/") ? path : "/" + path;
      var endpoint = cleanedRoot + normalized;
      if (!endpoint.endsWith(".js")) {
        endpoint += ".js";
      }
      return endpoint;
    };

    var addEndpoint = buildEndpoint(addPath);
    var cartEndpoint = buildEndpoint(basePath);

    var emit = function (name, detail) {
      document.dispatchEvent(
        new CustomEvent(name, detail ? { detail: detail } : undefined),
      );
    };

    var updateOrder = function (id) {
      try {
        var storageKey = "fluco_cart_order";
        var existing = localStorage.getItem(storageKey);
        var parsed = existing ? JSON.parse(existing) : [];
        if (!Array.isArray(parsed)) {
          parsed = [];
        }
        var updated = [id].concat(
          parsed.filter(function (storedId) {
            return storedId !== id;
          }),
        );
        localStorage.setItem(storageKey, JSON.stringify(updated));
      } catch (error) {
        // no-op
      }
    };

    var sortCart = function (cart) {
      try {
        var storageKey = "fluco_cart_order";
        var existing = localStorage.getItem(storageKey);
        var parsed = existing ? JSON.parse(existing) : [];
        if (Array.isArray(parsed) && parsed.length) {
          cart.sorted = cart.items.slice().sort(function (a, b) {
            return parsed.indexOf(a.variant_id) - parsed.indexOf(b.variant_id);
          });
          return cart;
        }
      } catch (error) {
        // no-op
      }
      cart.sorted = cart.items;
      return cart;
    };

    var fetchCart = function () {
      return fetch(cartEndpoint, {
        method: "GET",
        credentials: "include",
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          return sortCart(cart);
        });
    };

    emit("cart:updating");
    button.disabled = true;
    button.setAttribute("aria-busy", "true");

    fetch(addEndpoint, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: 1,
          },
        ],
      }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        if (data && (data.status === 422 || data.status === "422")) {
          var errorMessage = data.description || "Unable to add to cart";
          emit("cart:error", {
            message: errorMessage,
          });
          throw new Error(errorMessage);
        }
        updateOrder(variantId);
        var lineItem = data && data.items ? data.items[0] : data;
        if (lineItem) {
          emit("cart:item-added", {
            product: lineItem,
          });
        }
        return fetchCart().then(function (cart) {
          if (window.theme) {
            window.theme.cartData = cart;
          }
          window.emit("quick-cart:updated", cart);
          window.emit("quick-cart:open", cart);
          window.emit("cart:updated", cart);
          document.dispatchEvent(new CustomEvent("quick-cart:updated"));
          return cart;
        });
      })
      .catch(function (error) {
        if (error && error.message) {
          emit("cart:error", {
            message: error.message,
          });
        }
      })
      .finally(function () {
        button.disabled = false;
        button.removeAttribute("aria-busy");
      });
  };

  var initializeSection = function (section) {
    if (!section || section.dataset[INITIALIZED_ATTR] === "true") {
      return;
    }
    var addToCartButtons = section.querySelectorAll(BUTTON_SELECTOR);
    if (!addToCartButtons.length) {
      return;
    }

    section.dataset[INITIALIZED_ATTR] = "true";

    var listeners = [];
    var addListener = function (target, eventName, handler, options) {
      if (!target) {
        return;
      }
      target.addEventListener(eventName, handler, options || false);
      listeners.push(function () {
        target.removeEventListener(eventName, handler, options || false);
      });
    };

    addToCartButtons.forEach(function (button) {
      addListener(
        button,
        "click",
        function (event) {
          if (event) {
            event.preventDefault();
            event.stopPropagation();
            if (event.stopImmediatePropagation) {
              event.stopImmediatePropagation();
            }
          }
          var variantId = button.getAttribute(VARIANT_ATTR);
          addItemToCart(variantId, button);
        },
        { capture: true },
      );
    });

    var cleanup = function () {
      listeners.forEach(function (unsubscribe) {
        unsubscribe();
      });
      listeners = [];
      delete section.dataset[INITIALIZED_ATTR];
      cleanupMap.delete(section);
    };

    cleanupMap.set(section, cleanup);
  };

  var destroySection = function (section) {
    if (!section) {
      return;
    }
    var cleanup = cleanupMap.get(section);
    if (cleanup) {
      cleanup();
    }
  };

  var initAll = function (root) {
    findSections(root || document).forEach(initializeSection);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    if (!event || !event.target) {
      return;
    }
    initAll(event.target);
  });

  document.addEventListener("shopify:section:unload", function (event) {
    var section = null;
    if (event && event.detail && event.detail.sectionId) {
      var wrapper = document.getElementById(
        "shopify-section-" + event.detail.sectionId,
      );
      if (wrapper) {
        section = wrapper.querySelector(SECTION_SELECTOR);
      }
    }
    if (!section && event && event.target) {
      if (event.target.matches && event.target.matches(SECTION_SELECTOR)) {
        section = event.target;
      } else if (event.target.querySelector) {
        section = event.target.querySelector(SECTION_SELECTOR);
      }
    }
    destroySection(section);
  });
})();
